import { render } from "./localizedInput.vue?vue&type=template&id=331c4116&scoped=true&ts=true"
import script from "./localizedInput.vue?vue&type=script&lang=ts"
export * from "./localizedInput.vue?vue&type=script&lang=ts"

import "./localizedInput.vue?vue&type=style&index=0&id=331c4116&scoped=true&lang=css"

import exportComponent from "C:\\projects\\Auraclub\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-331c4116"]])

export default __exports__